<template>
	<a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
			<a-row :gutter="[24, 8]">
				<a-col :span="12">
					<a-form-item label="项目名称" name="projectName">
						<a-input v-model:value="form.projectName" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目总投资(万元)" name="investment">
						<a-inputNumber style="width: 100%" v-model:value="form.investment" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目开始时间" name="startTimeInterva">
						<date-picker style="width: 100%" v-model:value="form.startTimeInterva" :format="dateFormat.DATE_DAY"
							:showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目结束时间" name="endTimeInterva">
						<date-picker style="width: 100%" v-model:value="form.endTimeInterva" :format="dateFormat.DATE_DAY"
							:showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目负责人" name="projectLinkman">
						<a-input v-model:value="form.projectLinkman" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="联系电话" name="phone">
						<a-input v-model:value="form.phone" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="年研发经费(万元)" name="researchGrant">
						<a-inputNumber style="width: 100%" v-model:value="form.researchGrant" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="高新领域" name="researchField">
						<DictSelect v-model:value="form.researchField" :dict-name="education.RESEARCH_FIELD" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目阶段" name="projectPhase">
						<DictSelect v-model:value="form.projectPhase" :dict-name="'projectStage'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目分类" name="projectType">
						<DictSelect v-model:value="form.projectType" :dict-name="'project_type'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="行业类型" name="industry">
						<DictSelect v-model:value="form.industry" :dict-name="'projectType'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="项目需求" name="projectDemand">
						<DictSelect v-model:value="form.projectDemand" :dict-name="'project_demand'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="项目概述" name="projectView">
						<a-textarea v-model:value="form.projectView" placeholder="请输入" :rows="4" showCount />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="项目图片" name="picture">
						<img-upload v-model:value="form.picture" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="附件" name="file">
						<file-upload v-model:value="form.file" />
					</a-form-item>
				</a-col>
				<!--可编辑区域 end-->
			</a-row>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { corpProjectInfo } from "@/api/achievementsService";
import DictSelect from "@/components/other/DictSelect";
import { education, dateFormat } from "@/config/variableConfig";

export default {
	name: "UserModal",
	components: { DictSelect },

	mixins: [formMixin],
	data() {
		return {
			education,
			dateFormat,
			companyData: [],
			form: {
				id: null,
			},
			rules: {
				phone: [dataCheck.required({}), dataCheck.mobile_phone,],
				projectName: [dataCheck.required({})],
				investment: [dataCheck.required({ type: 'number' })],
				startTimeInterva: [],
				endTimeInterva: [],
				projectLinkman: [dataCheck.required({})],
				projectPhase: [dataCheck.required({})],
				researchField: [dataCheck.required({})],
				researchGrant: [dataCheck.required({ type: 'number' })],
				projectView: [],
				projectDemand: [dataCheck.required({})],
				projectType: [dataCheck.required({})],
				industry: [dataCheck.required({})],
				picture: [],
				file: [],
				companyCode: [dataCheck.required({})],
				id: [],
			},
			submitUrl: corpProjectInfo.saveOrUpdate
		}
	},
}
</script>
<style scoped lang="less"></style>
